var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaraNegIi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1190.24 316.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "saraNeg_ii_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "425.28 113.72 451.06 180.42 399.51 180.42 425.28 113.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.2,125.85q0,14.78-9.1,22.93t-27.28,8.15h-32.6V94.77h32.6q18.18,0,27.28,8.15T737.2,125.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "972.56 113.72 998.33 180.42 946.78 180.42 972.56 113.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V316.78H1190.24V0ZM1040.78,291.09,1023,244.85H922.15l-17.81,46.24H737.58l-45.1-66.7H668.22v66.7H493.5l-17.81-46.24H374.88l-17.82,46.24h-91l11.44-26.18q-12.6,12.12-31.71,20.31Q218,297.16,178.18,297.16a278.62,278.62,0,0,1-64.24-7.39q-31.27-7.39-51.36-19.9l28.81-65.19a182.82,182.82,0,0,0,42.44,17.62,165.64,165.64,0,0,0,45.1,6.64q18.57,0,26.53-3.6t8-10.81q0-8.33-10.42-12.5t-34.3-9.1Q138,186.5,117.54,179.1a87.1,87.1,0,0,1-35.63-24.26Q66.75,138,66.75,109.17a78.69,78.69,0,0,1,14-45.48q14-20.46,41.88-32.21T190.3,19.73a246,246,0,0,1,53.63,5.87q26.34,5.88,46.43,17.25l-26.91,64.81Q224.41,88,189.55,88q-34.5,0-34.49,16.67,0,8,10.23,11.94T199,125.09q30.32,5.68,51.17,13.08a89,89,0,0,1,36.19,24.06q15.35,16.68,15.35,45.48c0,.64,0,1.28,0,1.92L382.08,25.79H470L578.78,274.62V25.79H706.5q36.77,0,64.05,12.13t42.07,34.87q14.78,22.74,14.78,53.06,0,28.43-12.88,49.65t-37.15,33.73l43.72,64.23L929.35,25.79h87.93l116,265.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaraNegIi);
export default __webpack_public_path__ + "static/media/saraNeg_ii.82735ebc2d82a6cd001a38d49f2263de.svg";
export { ForwardRef as ReactComponent };